/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { checkIsActive } from "../../../../_helpers";
import { shallowEqual, useSelector } from "react-redux";
import { RoleChecker } from "../../../../../app/RoleChecker";
import { useFeatureChecker } from "../../../../../app/useFeatureChecker";

export function HeaderMenu({ layoutProps }) {
  const location = useLocation();
  const getMenuItemActive = url => {
    return checkIsActive(location, url) ? "menu-item-active" : "";
  };

  // Getting curret state of user data from store (Redux)
  const { user } = useSelector(
    state => ({ user: state.auth.user }),
    shallowEqual
  );

  const getCondition = () => {
    if (user.is_admin) {
      return true;
    } else {
      if (user.organization)
        if (
          !user.organization.simpz_status ||
          user.organization.simpz_status == "ACTIVE"
        ) {
          return true;
        } else {
          return false;
        }
    }
  };

  const CheckFeature = useFeatureChecker();

  return (
    <div
      id="kt_header_menu"
      className={`header-menu header-menu-left header-menu-mobile d-print-none ${layoutProps.ktMenuClasses}`}
      {...layoutProps.headerMenuAttributes}
    >
      {/*begin::Header Nav*/}
      {getCondition() && (
        <ul className={`menu-nav d-print-none ${layoutProps.ulClasses}`}>
          {user && user.is_admin ? null : (
            <>
              {/*begin::1 Level*/}
              <li
                className={`menu-item menu-item-rel ${getMenuItemActive(
                  "/donasi/counter/new"
                )}`}
              >
                <NavLink className="menu-link" to="/donasi/counter/new">
                  <span className="menu-text">Donasi Baru</span>
                  {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
                </NavLink>
              </li>
              <li
                className={`menu-item menu-item-rel ${getMenuItemActive(
                  "/donatur/new"
                )}`}
              >
                <NavLink className="menu-link" to="/donatur/new">
                  <span className="menu-text">Donatur Baru</span>
                  {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
                </NavLink>
              </li>
              {CheckFeature("SETTLE") && (
                <li
                  className={`menu-item menu-item-rel ${getMenuItemActive(
                    "/donasi/bank-import/new"
                  )}`}
                >
                  <NavLink className="menu-link" to="/donasi/bank-import/new">
                    <span className="menu-text">Import Transaksi Bank</span>
                    {layoutProps.rootArrowEnabled && (
                      <i className="menu-arrow" />
                    )}
                  </NavLink>
                </li>
              )}
              <li
                className={`menu-item menu-item-rel ${getMenuItemActive(
                  "/donasi/import-donation/new"
                )}`}
              >
                <NavLink className="menu-link" to="/donasi/import-donation/new">
                  <span className="menu-text">
                    Import Donasi EChannel /Counter
                  </span>
                  {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
                </NavLink>
              </li>
            </>
          )}
        </ul>
      )}
      {/*end::Header Nav*/}
    </div>
  );
}
